import { TenantRoleType } from '../viewModels/Enums';

export class TenantUser {

  static Empty(): TenantUser {
    return new TenantUser('', '', '', '', '', '', TenantRoleType.TenancyNoAccess);
  }

  id: string = '';
  tenantId: string = '';
  name: string = '';
  firstName: string = '';
  lastName: string = '';
  email: string = '';
  status?: string = '';
  lastLogin?: Date;
  invitationTimeUtc: Date | undefined;
  picture?: string = '';
  role: TenantRoleType;
  isResendProcess?: boolean;


  constructor(id: string, name: string, firstName: string, lastName: string, email: string, tenantId: string, role: TenantRoleType, status?: string, lastLogin?: Date, picture?: string, isResendProcess?: boolean) {
    this.id = id;
    this.tenantId = tenantId;
    this.name = name;
    this.firstName = firstName;
    this.lastName = lastName;
    this.email = email;
    this.status = status;
    this.lastLogin = lastLogin;
    this.picture = picture;
    this.role = role;
    this.isResendProcess = isResendProcess;
  }
}
